export class SIQEmailTranscriptTheme {
  textFieldTintColor = "null";
}
//# sourceMappingURL=SIQEmailTranscriptTheme.js.map